import SEO from '../components/seo';
import Wrapper from '../layout/wrapper';
import CourseDetailsMain from '../components/curso-detalhes';

const CourseDetails = () => {
  return (
    <Wrapper>
      <SEO pageTitle={'Detalhes do Curso'} />
      <CourseDetailsMain/>
    </Wrapper>
  );
};

export default CourseDetails;